import {
  EDIT_ACCESS_RECEIVED,
  SET_ACCESSES_RECEIVED,
  RESET_ACCESSES_RECEIVED,
} from '../actions/accessReceivedActions';

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case EDIT_ACCESS_RECEIVED:
      return state.map(access => (
        access._id === action.value._id ? { ...access, ...action.value } : access
      ));
    case SET_ACCESSES_RECEIVED:
      return action.value;
    case RESET_ACCESSES_RECEIVED:
      return initialState;
    default:
      return state;
  }
}
